import type { BenefitsSchema } from '@ecomm/city-state-data/cityStateSchema'
import { ContentfulImage } from '@ecomm/contentful-components'
import { BenefitsRichText } from '../../BenefitsRichText'

export type BenefitsProps = BenefitsSchema & {
  readonly location: string
}

export function Benefits({ text, images, location }: BenefitsProps) {
  return (
    <div className="flex flex-col gap-6 lg:flex-row lg:gap-20">
      <BenefitsRichText location={location} text={text} />
      <div className="flex flex-col gap-4 md:flex-row lg:flex-col lg:gap-11">
        {images.map((image, i) => (
          <ContentfulImage
            key={i}
            {...image}
            className="mx-auto h-[228px] w-full rounded-2xl lg:h-[407px] "
          />
        ))}
      </div>
    </div>
  )
}
